<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4fO0Mo/tc-custom/9781685506162.jpg?1716663162750" alt="This image is the cover for the book Sleighed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sleighed
      </h1>
      <p class="bookDescription body article font2">
        <p>Taylor Ariza has landed the job of his dreams as senior editor at Braxton Publishing Company. Within the first week on the job, he gets invited to the wedding of one of the sons of Taylor’s new employer. At the reception he meets a young man named Alex with the face of an angel and the vocabulary of a seasoned sailor. Taylor can overlook the language, but not the way the Braxton family treats Alex. After spending one glorious night together, Alex is the one Taylor wants to spend the rest of his life with.<br/><br/>Designer Alex Moore has always been the black sheep of his family because he’s loud, proud, and unapologetically gay. He doesn’t normally sleep around on a first date, but Taylor is hard to resist. Not only is he tall, dark, and handsome, but also charming, funny, and once Taylor finds out who Alex really is, he doesn’t back away, as Alex thought he might. Instead, he goes out of his way to prove to Alex none of that is important to him.<br/><br/>With the holidays rapidly approaching, Taylor is looking for a gift to sweep Alex off his feet, and he finds the perfect present in a Manhattan jewelry store. Will Alex accept the gift and make him the happiest guy on earth?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shawn Bailey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?401daeba